module.exports = __webpack_public_path__ + "static/media/image.31ff4aec.jpg";